export default function SSquareSelectedCheckBox({ size = 24, className = "", ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M5 21C4.45 21 3.97933 20.8043 3.588 20.413C3.19667 20.0217 3.00067 19.5507 3 19V5C3 4.45 3.196 3.97933 3.588 3.588C3.98 3.19667 4.45067 3.00067 5 3H19C19.1333 3 19.2583 3.01267 19.375 3.038C19.4917 3.06333 19.6083 3.10067 19.725 3.15L17.875 5H5V19H19V12.35L21 10.35V19C21 19.55 20.8043 20.021 20.413 20.413C20.0217 20.805 19.5507 21.0007 19 21H5ZM11.525 17L5.875 11.35L7.275 9.95L11.525 14.2L20.7 5.025L22.125 6.4L11.525 17Z"
            fill="currentColor"/>
    </svg>

  )
}